import { ParentProps, createContext, createEffect, createMemo, createSignal, Show, For, Switch, Match } from 'solid-js'
import { requireContext } from 'common'
import { K12GradreqGradeLayoutContext } from './K12GradreqGradeLayoutContext'
import styles from './sis-k12-gradreq-grade-layout.module.css'
import { Popover, requireViewContext } from 'st-app'
import K12GradReqGradeLayoutApi from '../../api/sis-k12-gradreq-grade-layout';
import { CourseCreditResult, CreditGradeData, CreditType, GradReqStuCreditGradeJson, RequirementStatus, RowData, TermData } from '../../api'
import { Spinner as StSpinner } from 'st-app'
import { ViewContext } from 'st-app/components/st-view/ViewContext'
import { style } from 'solid-js/web'

const K12GradreqGradeLayoutContextJsx = createContext<K12GradreqGradeLayoutContext>();
export const requireK12GradreqGradeLayoutContext = () => {
    return requireContext(K12GradreqGradeLayoutContextJsx);
}

export class K12GradreqGradeLayoutProps { }

export default function K12GradreqGradeLayout(props: ParentProps<K12GradreqGradeLayoutProps>) {
    const context = new K12GradreqGradeLayoutContext();

    return (
        <K12GradreqGradeLayoutContextJsx.Provider value={context}>
            <K12GradreqGradeLayoutInternal {...props} />
        </K12GradreqGradeLayoutContextJsx.Provider>
    )
}
function K12GradreqGradeLayoutInternal(props: ParentProps<K12GradreqGradeLayoutProps>) {
    const [rowData, setRowData] = createSignal<RowData | undefined>(undefined);

    const viewContext: ViewContext = requireViewContext();
    const json = createMemo(() => viewContext.identity());

    createEffect(() =>
    {
        if (json() === '') return;
        console.log(json())
        K12GradReqGradeLayoutApi.GetDataObject(json()).then((value) => { setRowData(value); console.log(value); });
    });

    return (
        <Switch fallback={<div class={styles.spinnerHolder}><StSpinner /></div>}>
            <Match when={rowData() != undefined && rowData()?.result != null}>
                <div class={styles['sis-k12-gradreq-grade-layout']}>
                    <div class={styles.header}>
                        <Summary status={rowData()?.result.creditData.status ?? RequirementStatus.None} statusDesc={rowData()?.requirementStatusLookups[rowData()?.result.creditData.status ?? RequirementStatus.None] ?? ''} requiredCreditTotal={rowData()?.result.creditData.totalRequiredCredits ?? 0} creditsNeeded={rowData()?.result.creditData.totalNeededCredits ?? 0} />
                        <Show when={Object.keys(rowData()?.result.creditData.creditDataByGrade ?? {}).length > 0}>
                            <div class={styles.headerCard}>
                                <div class={styles.headerGrade}>
                                    <span class={styles.headerGradeLabel}>Grade</span>
                                    {/* Put grade levels here */}
                                    <For each={Object.entries(rowData()?.result.creditData.creditDataByGrade ?? {})}>{
                                        ([key, val]) =>
                                            <GradeSummary
                                                gradePeriods={rowData()?.districtGradePeriodLookups ?? {}}
                                                currentGrade={rowData()?.grade == key} grade={rowData()?.gradeLookups[key] ?? ""}
                                                completedCredits={val.completedCredits ?? 0}
                                                requestedCredits={val.requestedCredits ?? 0}
                                                thresholds={val ?? new CreditGradeData()}
                                            />
                                    }</For>
                                </div>
                            </div>
                        </Show>
                    </div>
                    <For each={Object.entries(rowData()?.result.creditData.gradesBySubjectArea ?? {})}>{
                        ([key, val]) =>
                            <div class={styles.subjectAreasContainer}>
                                <SubjectArea grades={Object.keys(rowData()?.result.creditData.creditDataByGrade ?? {})} subjectAreaCode={key} currentGrade={rowData()?.grade ?? ""} subjectAreaLookups={rowData()?.subjectAreaLookups ?? {}} organizations={val ?? new GradReqStuCreditGradeJson()} />
                            </div>
                    }</For>
                </div>
            </Match>
        </Switch>
        
    );
}

interface GradeSummaryProps {
    grade: string,
    completedCredits: number,
    requestedCredits: number,
    currentGrade: boolean,
    gradePeriods: Record<string, string>,
    thresholds: CreditGradeData
}

function GradeSummary(props: ParentProps<GradeSummaryProps>) {
  
    interface StatusIconProps {
        type: "grade" | "term"
        term?: string
    }

    // Get an icon for the grade depending on the status
    const StatusIcon = (statusProps: ParentProps<StatusIconProps>) => {
        return (
            <span class={`fa-solid ${(statusProps.type == "grade" ? getIconClasses(props.thresholds.gradeStatus) : getIconClasses(props.thresholds.statusByTerm[statusProps.term!]?.termStatus))}`} />
        )
    }

    const getTermCredits = (gradePeriod: string): string => {
        var res: string = ""

        const gp: TermData = props.thresholds.statusByTerm[gradePeriod]

        if (gp.completedCredits > 0) {
            res = `Completed: ${gp.completedCredits}`
        } else if (gp.inProgressCredits > 0) {
            res = `In Progress: ${gp.inProgressCredits}`
        } else if (gp.requestedCredits > 0) {
            res = `Requested: ${gp.requestedCredits}`
        }

        return res
    }

    const log = () => {
        console.log(props.thresholds)
        return ""
    }

    return (
        <div class={styles.headerGradeProgress}>
            { log() }
            <span class={styles.headerGradeProgressTitle}><StatusIcon type="grade" />{props.grade}</span>
            <span class={styles.headerGradeProgressCredits}>Completed: {props.completedCredits} / {props.thresholds.creditThresholdPeriods[props.thresholds.creditThresholdPeriods.length - 1].onTrack ?? 0} credits</span>
            <Show when={props.requestedCredits > 0}><span class={styles.headerGradeProgressCredits}>Requested: {props.requestedCredits} credits</span></Show>
            <Show when={props.currentGrade && Object.entries(props.thresholds.statusByTerm).length > 0}>
                <div class={styles.headerGradeTermBreakdownContainer}>
                    <For each={Object.entries(props.gradePeriods ?? {})}>{
                        ([key, val]) => (
                            <div class={styles.headerGradeTermBreakdown}>
                                <span class={styles.headerGradeTermLabel}><StatusIcon type="term" term={key} />{val}</span>
                                <span>{getTermCredits(key)}</span>
                            </div>
                        )
                    }</For>
                </div>
            </Show>
        </div>
    )
}


const getIconClasses = (status: RequirementStatus): string => {
    var res: string = "fa-solid "

    switch (status) {
        case RequirementStatus.None:
            res = "";
            break;
        case RequirementStatus.AtRisk:
            res += `fa-triangle-exclamation ${styles.summaryIconAtRisk}`
            break;
        case RequirementStatus.Met:
        case RequirementStatus.OnTrack:
            res += `fa-circle-check ${styles.summaryIconMet}`
            break;
        case RequirementStatus.NotMet:
        case RequirementStatus.OffTrack:
            res += `fa-circle-exclamation ${styles.summaryIconNotMet}`
            break;
        default:
            res += `fa-circle-question ${styles.summaryIconMissing}`
            break;
    }

    return res
}

interface SummaryProps
{
    status: RequirementStatus;
    statusDesc: string;
    requiredCreditTotal: number;
    creditsNeeded: number;
}

function Summary(props: ParentProps<SummaryProps>)
{
    return (
        <div class={styles.summaryHeader}>
            <div class={styles.summaryContainer}>
                <div class={styles.summaryStatus}><span class={getIconClasses(props.status)} />{props.statusDesc}</div>
                <div class={styles.creditTotals}>Required Credit Total: <span class={styles.creditTotalResult}>{props.requiredCreditTotal}</span></div>
                <div class={styles.creditTotals}>Subject Area Credits Needed: <span class={styles.creditTotalResult}>{props.creditsNeeded}</span></div>
            </div>
        </div>
    )
}

K12GradreqGradeLayout.defaultProps = new K12GradreqGradeLayoutProps();

class SubjectAreaProps {
    subjectAreaCode: string = ""
    subjectAreaLookups: Record<string, string> = {}
    currentGrade: string = ""
    organizations: GradReqStuCreditGradeJson = new GradReqStuCreditGradeJson()
    grades: string[] = []
}

function SubjectArea(props: ParentProps<SubjectAreaProps>) {

    // Checks if the student's grade matches the column for styling
    function getClassesForSubArea(subArea: string): string {
        var res = styles.grade;

        if (subArea == props.currentGrade) {
            res += ` ${styles.current}`;
        }

        return res;
    }

    function getClassesForSubAreaIcon(): string {
        var res: string = "fa-solid";

        res += props.organizations.completedCredits >= props.organizations.requiredCredits ? ` fa-circle-check ${styles.subjectAreaIconMet}` : ` fa-circle-exclamation ${styles.subjectAreaIconNotMet}`;

        return res;
    }

    return (
        <div class={styles['sis-k12-gradreq-grade-layout-subjectarea']}>
            <div class={styles.subjectAreaHeader}>
                <span class={getClassesForSubAreaIcon()} />
                <span class={styles.headerSubjectAreaName}>{props.subjectAreaLookups[props.subjectAreaCode]}</span>
                <span class={styles.headerCredits}>({props.organizations.completedCredits ?? 0} of {props.organizations.requiredCredits ?? 0} credits)</span>
            </div>
            <div class={styles.breakdown}>
                <span class={styles.breakdownText}><span class="fa fa-lock" /> Completed: {props.organizations.completedCredits ?? 0} credits, <span class="fa fa-file-pen" /> In Progress: {props.organizations.inProgressCredits ?? 0} credits, <span class="fa fa-person-circle-question" /> Requested: {props.organizations.forecastedCredits ?? 0} credits</span>
            </div>
            <div class={styles.gradeContainer}>
                <For each={props.grades}>{
                    (code, index) =>
                        <div class={getClassesForSubArea(code)}>
                            <For each={Object.entries(props.organizations.orgsByGradeJson[code]?.creditResultsByOrg ?? {})}>{
                                ([key, val]) =>
                                    <Organization organizationName={val[0].organizationName ?? key} courses={val} popoverLeft={index() >= (props.grades.length / 2)} subjectAreaLookups={props.subjectAreaLookups} />
                            }</For>
                        </div>
                }</For>
            </div>
        </div>
    );
}

class OrganizationProps {
    organizationName: string = ""
    courses: CourseCreditResult[] = []
    popoverLeft: boolean = false
    subjectAreaLookups: Record<string, string> = {}
}

function Organization(props: ParentProps<OrganizationProps>) {
    return (
        <div class={styles.organization}>
            <span class={styles.organizationLabel}>{props.organizationName}</span>
            <For each={props.courses}>{
                (crs) =>
                    <Course course={crs} popoverLeft={props.popoverLeft} subjectAreaLookups={props.subjectAreaLookups} />
            }</For>
        </div>
    )
}

class CourseProps {
    course: CourseCreditResult = new CourseCreditResult()
    popoverLeft: boolean = false
    subjectAreaLookups: Record<string, string> = {}
}

function Course(props: ParentProps<CourseProps>) {

    const translateSubjectAreas = (subjectAreas: string[]): string => {
        var res: string = ""

        var translated: string[] = []

        subjectAreas.forEach(sa => {
            const translation: string = props.subjectAreaLookups[sa]

            if (translation != null) {
                translated = [...translated, translation]
            } else {
                translated = [...translated, sa]
            }
        })

        res = translated.join(", ")

        return res
    }

    // Only show information we have on the course
    function CoursePopoverElements() {
        return (
            <>
                <Show when={props.course.courseID != ""}>
                    <span style="margin: 0px 0.2em">Course ID: <span style="font-weight: 700">{props.course.courseID}</span></span>
                </Show>
                <Show when={props.course.cteSubjectAreas.length > 0}>
                    <span style="margin: 0px 0.2em">CTE Subject Area(s): <span style="font-weight: 700">{translateSubjectAreas(props.course.cteSubjectAreas)}</span></span>
                </Show>
                <Show when={props.course.dateTaken != ""}>
                    <span style="margin: 0px 0.2em">Taken: <span style="font-weight: 700">{props.course.dateTaken}</span></span>
                </Show>
                <Show when={props.course.term != ""}>
                    <span style="margin: 0px 0.2em">Term: <span style="font-weight: 700">{props.course.term}</span></span>
                </Show>
                <Show when={props.course.mark != ""}>
                    <span style="margin: 0px 0.2em">Mark: <span style="font-weight: 700">{props.course.mark}</span></span>
                </Show>
                <Switch fallback={<span style="margin: 0px 0.2em">Credits: <span style="font-weight: 700">{props.course.creditsCompleted}</span></span>}>
                    <Match when={props.course.creditType == CreditType.Requested}>
                        <span style="margin: 0px 0.2em">Requested Credits: <span style="font-weight: 700">{props.course.creditsRequested}</span></span>
                    </Match>
                </Switch>
            </>
        )
    }

    function hoverCourse(hovered: boolean): void {
        const partialClass: string = `PARTIAL_${props.course.partialLink}`

        const elements: HTMLCollectionOf<Element> = document.getElementsByClassName(partialClass)

        for (var i = 0; i < elements.length; i++) {
            const element: Element = elements[i]

            if (hovered) {
                element.classList.add(styles.activeCourse);
            }
            else {
                element.classList.remove(styles.activeCourse);
            }
        }
    }

    function getCourseClasses(): string {
        var res: string = styles.courseInfo + ` PARTIAL_${props.course.partialLink}`;

        switch (props.course.creditType) {
            case CreditType.Requested:
                res += ` ${styles.requestedCourse}`;
                break;
            default:
                break;
        }

        return res;
    }

    function getCredits(): number {
        var res: number = props.course.creditsCompleted;

        switch (props.course.creditType) {
            case CreditType.Requested:
                res = props.course.creditsRequested;
                break;
            case CreditType.Scheduled:
            case CreditType.Grading:
                res = props.course.creditsInProgress;
                break;
            default:
                break;
        }

        return res;
    }

    function getIcon(): string {
        var res: string = "fa-lock";

        switch (props.course.creditType) {
            default:
            case CreditType.CourseHistory:
                break;
            case CreditType.Requested:
                res = "fa-person-circle-question";
                break;
            case CreditType.Scheduled:
            case CreditType.Grading:
                res = "fa-file-pen"
                break;
        }

        return res;
    }

    return (
        <Popover class={styles.credit} placement={props.popoverLeft ? "left-start" : "right-end"}>
            <Popover.Trigger>
                <div onMouseEnter={() => hoverCourse(true)} onMouseLeave={() => hoverCourse(false)} class={getCourseClasses()}>
                    <span class={`fa ${getIcon()}`} />
                    <span class={styles.courseTitle}>{props.course.courseTitle}</span>
                    <Show when={props.course.cteSubjectAreas.length > 0}><span class={`${styles.coursePartial} fa-solid fa-gears`}/></Show>
                    <Show when={props.course.partial}><span class={styles.coursePartial + " fa-solid fa-circle-half-stroke"} /></Show>
                    <Show when={props.course.districtGradePeriod}><span class={styles.courseTerm}>{ props.course.districtGradePeriod }</span></Show>
                    <span><Show when={props.course.mark != null}>{props.course.mark}</Show></span>
                    <div class={styles.courseResultsContainer}>
                        <span>{`(${getCredits()})`}</span>
                    </div>
                </div>
            </Popover.Trigger>
            <Popover.Content class={styles.creditInfo} >
                <div>
                    <CoursePopoverElements/>
                </div>
            </Popover.Content>
        </Popover>
    )
}